export class SmoothLine {
  // Reference - http://www.idav.ucdavis.edu/education/CAGDNotes/Chaikins-Algorithm/Chaikins-Algorithm.html
  static smooth(input) : Array<any> {
    let output = [];

    // Add start item
    if (input.length>0)
        output.push(this.copyVec(input[0], [0, 0]));

    for (let i=0; i<input.length-1; i++) {
      let p1 = input[i+1],
          p0 = input[i],
          p0x = p0[0],
          p0y = p0[1],
          p1x = p1[0],
          p1y = p1[1];

      let Q = [ 0.75 * p0x + 0.25 * p1x, 0.75 * p0y + 0.25 * p1y ];
      let R = [ 0.25 * p0x + 0.75 * p1x, 0.25 * p0y + 0.75 * p1y ];
      output.push(Q);
      output.push(R);
    }

    // Add end item
    if (input.length > 1)
        output.push(this.copyVec(input[ input.length-1 ], [0, 0]));
    return output;
  }

  static copyVec(source, target) {
    target[0] = source[0]
    target[1] = source[1]
    return target;
  }
}


// WEBPACK FOOTER //
// src/components/map/smooth-line.ts